export default __webpack_public_path__ + "static/media/icon_checkbox.ea193018.svg";